import React from 'react';

import { CaseOverviewTabContent } from '../case-overview-tab-content';

export const Case3OverviewTabContent = React.memo(() => {
  return (
    <CaseOverviewTabContent
      title={'AI Driven IT Operations'}
      description={
        'Use of machine learning on operations data collected from BSS application ecosystem to intelligently pinpoint performance bottlenecks and predict potential service quality degradation.'
      }
      assetType={'case3'}
    />
  );
});
